// extracted by mini-css-extract-plugin
module.exports = {"info":"_f5e233e","hide":"_6865d8b"};